(function () {
  const SWIPER_KEY = '_swiperMulticolumn';

  const initSlider = (section) => {
    const grid = section.querySelector(".multicolumn-grid[data-layout='slider']");
    if (!grid) return;

    const wrapper = grid.querySelector(".multicolumn-grid__wrapper");
    const cards = grid.querySelectorAll(".multicolumn-card");
    if (!wrapper || !cards.length) return;

    if (cards.length < 4) {
      grid.dataset.layout = 'grid';
      const nav = grid.querySelector(".multicolumn-nav");
      if (nav) nav.style.display = 'none';
      return;
    }

    grid.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    cards.forEach((card) => card.classList.add("swiper-slide"));

    const prevBtn = grid.querySelector(".multicolumn-nav-button--prev");
    const nextBtn = grid.querySelector(".multicolumn-nav-button--next");
    const columns = Number(grid.dataset.columns) || 3;

    const containerEl = section.querySelector(".container, .page-width");
    const offset = containerEl ? parseFloat(getComputedStyle(containerEl).paddingLeft) : 32;

    const breakpoints = {
      2: {
        576: { slidesPerView: 2, spaceBetween: 24 },
      },
      3: {
        576: { slidesPerView: 2, spaceBetween: 24 },
        990: { slidesPerView: 3.5, spaceBetween: 24 },
      },
      4: {
        576: { slidesPerView: 2, spaceBetween: 24 },
        990: { slidesPerView: 3, spaceBetween: 24 },
        1360: { slidesPerView: 4, spaceBetween: 24 },
      },
    };

    section[SWIPER_KEY] = new Swiper(grid, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      speed: 800,
      centeredSlides: false,
      slidesOffsetBefore: offset,
      slidesOffsetAfter: offset,
      allowTouchMove: true,
      mousewheel: { forceToAxis: true },
      a11y: { scrollOnFocus: false },
      preventClicks: true,
      breakpoints: breakpoints[columns] || breakpoints[3],
      navigation: prevBtn && nextBtn ? {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: "swiper-button-disabled",
      } : false,
    });
  };

  const destroySlider = (section) => {
    const swiper = section[SWIPER_KEY];
    if (!swiper) return;
    const grid = section.querySelector(".multicolumn-grid");
    const wrapper = grid && grid.querySelector(".multicolumn-grid__wrapper");
    const cards = grid && grid.querySelectorAll(".multicolumn-card");
    if (!grid || !wrapper) return;
    swiper.destroy(true, true);
    section[SWIPER_KEY] = null;
    grid.classList.remove("swiper");
    wrapper.classList.remove("swiper-wrapper");
    cards && cards.forEach((c) => c.classList.remove("swiper-slide"));
  };

  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("multicolumn-section")) return;
    const enableAnimation = section.querySelector("[data-enable-header-animation]");
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("anim-active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -25% 0px" }
    );
    observer.observe(section);
  };

  const init = (section) => {
    if (!section || !section.classList.contains("multicolumn-section")) return;
    initSlider(section);
    initHeadingAnimation(section);
  };

  init(document.currentScript.parentElement);

  if (!window._multicolumnListenersAdded) {
    window._multicolumnListenersAdded = true;
    document.addEventListener("shopify:section:load", (e) => init(e.target));
    document.addEventListener("shopify:section:unload", (e) => destroySlider(e.target));
  }
})();
